import type { EditorPlugin } from '../../types/aha-editor';
import type AhaEditor from '../../AhaEditor';
import { Editor, Element, Range, Text, Transforms } from 'slate';
import { isKeyHotkey } from 'is-hotkey';

const onKeyDown = (
  event: KeyboardEvent,
  ahaEditor: AhaEditor
): boolean | undefined => {
  const { editor, elementToolbarItems } = ahaEditor;
  const { selection } = editor;

  if (!isKeyHotkey('Escape', event)) return;

  if (!selection || !Range.isCollapsed(selection)) return;

  const element = Editor.above(editor, {
    at: selection.focus,
    mode: 'lowest',
    match: (n) => Element.isElement(n) && elementToolbarItems.has(n.type),
  });
  if (!element) return;

  // Get the next text node after the inline.
  const next = Editor.next<Text>(editor, {
    mode: 'lowest',
    at: Editor.end(editor, element[1]),
    match: (n) => Text.isText(n),
  });

  if (next) {
    event.preventDefault();
    // Set the cursor position to the start of the next text node.
    Transforms.select(editor, { path: next[1], offset: 0 });
    return true;
  }
};

const EscapeToolbarPlugin: EditorPlugin = {
  name: `Escape toolbar key handler plugin`,
  handlers: {
    onKeyDown,
  },
};

export default EscapeToolbarPlugin;
